import React, { useState } from 'react';
import { Editor, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { isBlockActive } from './helpers/utilities';
import { insertLink, removeLink } from './helpers/linkHelpers';
import LinkIcon from '@material-ui/icons/Link';
import LinkEditDialog from './LinkEditDialog';
import ButtonBase from './ButtonBase';

interface Props {
  editor: ReactEditor;
}

function LinkButton({ editor }: Props) {
  const [showEditDialog, setShowEditDialog] = useState(false);
  const isActive = isBlockActive(editor, 'link');
  const [displayText, setDisplayText] = useState('');
  const [href, setHref] = useState('');
  const [selection, setSelection] = useState<any>();

  const handleInsertLink = () => {
    // (note - pearl) If no selection, insert at the start of the editor
    const _selection = selection || {
      anchor: Editor.start(editor, []),
      focus: Editor.start(editor, []),
    };

    Transforms.select(editor, _selection);
    insertLink(editor, { href, text: displayText });
    setDisplayText('');
    setHref('');
  };
  const toggleLink = () => {
    setShowEditDialog(!isActive);

    if (isActive) {
      removeLink(editor);
    } else {
      setSelection(editor.selection);
      !!editor.selection && setDisplayText(Editor.string(editor, editor.selection));
    }
  };
  const handleDisplayTextChange = (e: any) => {
    setDisplayText(e.target.value);
  };
  const handleHrefChange = (e: any) => {
    setHref(e.target.value);
  };
  const handleClose = () => {
    setShowEditDialog(false);
  };
  const handleRemoveLink = () => {
    handleClose();
  };
  const handleSave = () => {
    handleInsertLink();
    handleClose();
  };

  return (
    <>
      <ButtonBase onMouseDown={toggleLink} isActive={isActive}>
        <LinkIcon fontSize="small" />
      </ButtonBase>
      <LinkEditDialog
        displayText={displayText}
        href={href}
        open={showEditDialog}
        onClose={handleClose}
        onDisplayTextChange={handleDisplayTextChange}
        onHrefChange={handleHrefChange}
        onRemoveLink={handleRemoveLink}
        onSave={handleSave}
      />
    </>
  );
}

export default LinkButton;
